import { Alert, Box, CircularProgress, Grid, Stack } from "@mui/material";

import DashboardHeader from "./components/DashboardHeader";
import InventoryDistribution from "./components/InventoryDistribution";
import LowStockTable from "./components/LowStockTable";
import PurchaseTrend from "./components/PurchaseTrend";
import QuickActions from "./components/QuickActions";
import RecentActivity from "./components/RecentActivity";
import SummaryCards from "./components/SummaryCards";
import OperationalPulse from "./components/OperationalPulse";
import { useDashboard } from "./hooks/useDashboard";

const Dashboard = () => {
  const { data, error, loading, refetch } = useDashboard();

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 1.75, lg: 2 },
        minHeight: "calc(100vh - 96px)",
        borderRadius: { xs: 2, md: 3 },
        background: (theme) =>
          theme.palette.mode === "dark"
            ? "linear-gradient(145deg, #090f1d 0%, #101a2d 48%, #0b1725 100%)"
            : "linear-gradient(155deg, rgba(239,246,255,.92), rgba(255,255,255,.96) 42%, rgba(240,253,250,.74))",
      }}
    >
      <Stack spacing={{ xs: 1.5, md: 2 }}>
        <DashboardHeader
          onRefresh={refetch}
          dashboard={data?.dashboard}
          inventory={data?.inventory}
        />

        {loading && (
          <Box display="flex" justifyContent="center" py={10}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" action={null}>
            {error}
          </Alert>
        )}

        {data && (
          <>
            <SummaryCards data={data.dashboard} />

            <QuickActions />

            <Grid container spacing={{ xs: 2, lg: 2.5 }} sx={{ minWidth: 0 }}>
              <Grid item xs={12} lg={7} sx={{ minWidth: 0 }}>
                <PurchaseTrend data={data.procurement.monthlyPurchase} />
              </Grid>

              <Grid item xs={12} md={6} lg={5} sx={{ minWidth: 0 }}>
                <InventoryDistribution data={data.inventory.categoryWise} />
              </Grid>
              <Grid item xs={12} md={6} lg={5} sx={{ minWidth: 0 }}>
                <OperationalPulse
                  dashboard={data.dashboard}
                  maintenance={data.maintenance}
                  procurement={data.procurement}
                />
              </Grid>
              <Grid item xs={12} lg={7} sx={{ minWidth: 0 }}>
                <LowStockTable data={data.inventory.deadStock} />
              </Grid>
              <Grid item xs={12} sx={{ minWidth: 0 }}>
                <RecentActivity data={data.inventory.movementSummary} />
              </Grid>
            </Grid>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default Dashboard;
